<template>
  <div v-if="load && showContent">
    <v-skeleton-loader type="article"></v-skeleton-loader>
  </div>
  <div v-else>
    <div v-if="showContent">
      <p v-for="(record, index) in dataText.text" :key="index">
        <span v-html="record"></span>
      </p>
      <div v-if="dataText.links">
        <p style="margin: 0;">Полезные ссылки для сотрудников:</p>


        <v-row class="my-0" style="height: 30px;" v-if="$model.isAdmin">
          <v-col cols="10" class="py-0">
          </v-col>
          <v-col>
            <v-icon icon="mdi-plus" color="success" @click="addLinkDialog = true"></v-icon>
          </v-col>
        </v-row>



        <v-row v-for="link_ in dataText.links" :key="link_.id" class="my-0" style="height: 30px;">
          <v-col cols="10" class="py-0">
            <a target="_blank" :href="link_.path">{{ link_.name }}</a>
          </v-col>
          <v-col>
            <v-icon icon="mdi-delete" @click="deleteLink(link_.id)"></v-icon>
          </v-col>
        </v-row>


      </div>

      <v-dialog v-model="addLinkDialog" max-width="450" persistent>
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-text-field variant="underlined" v-model="linkName" :rules="rules.linkName" label="Название ссылки"
                  onautocomplete="off"></v-text-field>
              </v-col>

              <v-col class="py-0">
                <v-text-field variant="underlined" v-model="url" :rules="rules.isURL" label="URL"
                  onautocomplete="off"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text="Сохранить" @click="saveLink()"></v-btn>
            <v-btn text="Закрыть" @click="addLinkDialog = false"></v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
    <div v-else class="cursor-pointer">
      <v-col class="d-flex flex-column align-center">
        <v-icon color="info" icon="mdi-account-group"></v-icon>
      </v-col>

      <v-col style="word-break: break-all" class="d-flex flex-column align-center">
        <span>Информация</span>
      </v-col>
    </div>
  </div>

</template>

<script>
import { isURL } from "moodleDir/procollege/lib/vue/helpers";
export default {
  props: {
    //поле data из psm_desktop_widgets
    data: {
      required: true,
    },
    showContent: {
      default: false,
      type: Boolean
    }
  },
  name: "usefulLinksWidget",
  data() {
    return {
      addLinkDialog: false,
      load: false,
      dataText: [],
      linkName: "",
      url: "",
      rules: {
        linkName: [
          (value) => {
            if (value?.length >= 3) return true;
            return "Укажите хотя бы 3 символа";
          },
        ],
        isURL: [
          (value) => !!value || "Required.",
          (value) => isURL(value) || "URL is not valid",
        ],
      },
    };
  },
  watch: {
    showContent: function (newVal) {
      if (newVal && this.dataText.length == 0) {
        this.loadData();
      }
    }
  },
  created() {
    if (!this.showContent) {
      return
    }
    this.loadData();
  },
  methods: {
    loadData() {
      this.load = true;
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/widgets/usefulLinks/get"
        )
        .then((response) => {
          this.dataText = response.data;
          this.load = false;
        })
        .catch((error) => {
          this.load = false;
          console.log(error);
        });
    },
    deleteLink(id) {
      this.load = true;
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/widgets/usefulLinks/delete",
          new URLSearchParams({
            id: id
          }),
        )
        .then((response) => {
          this.dataText = response.data;
          this.load = false;
        })
        .catch((error) => {
          this.load = false;
          console.log(error);
        })
    },
    saveLink() {
      this.addLinkDialog = false;
      this.load = true;
      this.axios
        .post(
          this.$model.wwwroot + "/procollege/psm_desktop2/widgets/usefulLinks/add",
          new URLSearchParams({
            url: this.url,
            name: this.linkName
          }),
        )
        .then((response) => {
          this.dataText = response.data;
          this.load = false;
        })
        .catch((error) => {
          this.load = false;
          console.log(error);
        });
    },
  },
};
</script>
<style lang="scss">
/*
#procollege_desktop2 {
}
*/
</style>
